import type { IconNode } from '../types';

/**
 * @name cent
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgOGE4IDggMCAxIDAgMCA4IiAvPgogIDxwYXRoIGQ9Ik0xMiAydjIwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/cent
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cent: IconNode = [
  ['path', { d: 'M19 8a8 8 0 1 0 0 8', key: 'oyt0an' }],
  ['path', { d: 'M12 2v20', key: 't6zp3m' }],
];

export default cent;
